import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7ed0891c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "teacher-main-wrapper"
};
const _hoisted_2 = {
  class: "teacher-wrapper"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "page-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-bottom": "10px"
  }
}, " 教学名师 "), /*#__PURE__*/_createElementVNode("img", {
  width: "240",
  src: "https://image.zhihuishu.com/zhs/b2cm/base1/202408/d29f247f465b4b2ea6fe66360a1ebd9d.png",
  alt: ""
}), /*#__PURE__*/_createElementVNode("div")], -1));

const _hoisted_4 = {
  class: "teacher-list"
};
const _hoisted_5 = {
  key: 1,
  class: "no-data"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TeacherCard = _resolveComponent("TeacherCard");

  const _component_Empty = _resolveComponent("Empty");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [$data.teacherList && $data.teacherList.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($data.teacherList, teacherData => {
    return _openBlock(), _createBlock(_component_TeacherCard, {
      teacherData: teacherData,
      key: teacherData.teacher_id,
      menu: $props.menu,
      class: "teacher-card"
    }, null, 8, ["teacherData", "menu"]);
  }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_Empty, {
    type: "people"
  })]))])])]);
}